export default "__VITE_ASSET__3c6a8BAI__"